<template>
  <div class="cookies" :class="setLayoutColor">
    <div class="cookies__banner">
      <div class="cookies__banner_text">
        Используя данный сайт, я выражаю свое <a :href="urlPD" target="_blank">согласие на обработку моих персональных данных</a>.
        Пожалуйста, ознакомьтесь с политикой конфиденциальности на <a :href="urlPolicy" target="_blank">странице</a>.
      </div>
      <div class="cookies__banner_button">
        <MainButton title="Принять" color="purple" @click="$emit('acceptCookies')" />
      </div>
    </div>
  </div>
</template>

<script>
import MainButton from "@/components/ui/Button/MainButton.vue";

export default {
  name: "CookieModal",
  components: {
    MainButton,
  },
  computed: {
    urlPolicy() {
	    const url = this.fileLinks?.["privacy-policy"]?.[0]?.link;
	    if (!url) {
		    return "";
	    }
	    const baseUrl =
		    process.env.NODE_ENV === "production"
			    ? window.location.origin
			    : "https://brixo.tz365.ru";
	    return `${baseUrl}${url}`;
    },
    urlPD() {
      const url = this.fileLinks?.["soglasie-na-obrabotku-PD"]?.[0]?.link;
      if (!url) {
        return "";
      }
      const baseUrl =
          process.env.NODE_ENV === "production"
              ? window.location.origin
              : "https://brixo.tz365.ru";
      return `${baseUrl}${url}`;
    },
    layoutColor() {
      return this.$store.getters.GET_LAYOUT_COLOR;
    },
    setLayoutColor() {
      return `cookies_${this.layoutColor}`;
    },
	  fileLinks() {
		  return this.$store.getters["content/GET_LINKS"];
	  }
  },
};
</script>

<style lang="scss" scoped>
.cookies {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10%;
  left: 45%;
  z-index: 1000;

  &_purple {
    & .cookies__banner_text {
      color: $color-purple-40;
    }
  }

  &_red {
    & .cookies__banner_text {
      color: $color-red-20;
    }
  }

  &__banner {
    position: fixed;
    max-width: 80vw;
    width: 100%;
    padding: 20px 40px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
    background-color: #fff;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    &_text {
      width: 80%;
      font-size: 14px;
      font-weight: 400;

      & a {
        color: $color-red;
      }
    }

    &_button {
      width: 150px;

      & .button {
        height: 48px;
      }
    }
  }
}
</style>
